'use strict';

// Mogo Space:
var ContentfulSpaceParams = {
  space_id: 'o53teuzp9vd4',
  accessToken: '54cd18203ef0aaa708b34d60c3f1b2999bf9d1d674f94c6079012eb00523c7da',
  verboseLevel: '2'
};

// App Space
var ContentfulAppSpaceParams = {
  space_id: '5s3ysw7vjfxb',
  accessToken: '6vbYwxmHR1agrTT8Wi_xHfjubGS-Kd9FrI93NpUyahs',
  verboseLevel: '2'
};

// if not production enable the preview api
if (location.hostname !== 'www.mogo.ca') {
  _ContentfulConfiguration.url = 'https://preview.contentful.com';
  ContentfulSpaceParams.accessToken = 'beca92cafc034f67fa638129fb4b79d23e22ff0a4203b7732912094bd0d882e7';
  ContentfulAppSpaceParams.accessToken = 'xFL0etAbaT2J_M7lPKdMrk4GS3inyS5zTqkIwASndnY';
}